'use strict';

function StatesTemplatesDialogController($scope, $mdDialog, statesTemplates) {
  'ngInject';

  $scope.statesTemplates = statesTemplates;
  $scope.selected = statesTemplates.reduce((obj, st) => {
    obj[st.id] = true;
    return obj;
  }, {});

  $scope.save = function() {
    $mdDialog.hide($scope.selected);
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default StatesTemplatesDialogController;
